import Vue from 'vue';

Vue.component('staff-role-index', () => import('./staff-role-index.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/staff/role/index.js